// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/scss/customize-controls.scss
// module id = ./resources/scss/customize-controls.scss
// module chunks = 0